import React, { useEffect, useState } from 'react';
import { api } from '../services/api';
import useInvalidate from '../hooks/useInvalidate';

export default function VendedoresPage({ pin, onToast }) {
  const [vendedores, setVendedores] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [nombre, setNombre] = useState('');
  const [telefono, setTelefono] = useState('');
  const [loginUsername, setLoginUsername] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);

  function load() {
    api
      .getVendedores()
      .then((r) => setVendedores(r.data || []))
      .catch((err) => {
        setVendedores([]);
        onToast?.(err.message || 'No se pudieron cargar vendedores', 'error');
      });
    api
      .getUsuarios()
      .then((r) => setUsuarios(r.data || []))
      .catch((err) => {
        setUsuarios([]);
        onToast?.(err.message || 'No se pudieron cargar usuarios', 'error');
      });
  }

  useEffect(() => {
    load();
  }, [pin]);

  useInvalidate(['seller', 'user'], load);

  function loginDe(vendedorId) {
    return usuarios.find((u) => u.rol === 'vendedor' && Number(u.vendedor_id) === Number(vendedorId) && u.activo);
  }

  async function guardar(e) {
    e.preventDefault();
    if (!nombre.trim()) return;
    setSaving(true);
    try {
      let vend;
      if (editId) {
        const res = await api.actualizarVendedor(editId, { nombre: nombre.trim(), telefono });
        vend = res.data;
        onToast?.('Vendedor actualizado');
      } else {
        const res = await api.crearVendedor({ nombre: nombre.trim(), telefono });
        vend = res.data;
        onToast?.('Vendedor creado');
        if (loginUsername.trim() && loginPassword.trim() && vend?.id) {
          await api.crearUsuario({
            nombre: nombre.trim(),
            username: loginUsername.trim(),
            password: loginPassword.trim(),
            rol: 'vendedor',
            vendedor_id: vend.id,
          });
          onToast?.('Vendedor creado con acceso a la app');
        }
      }
      setNombre('');
      setTelefono('');
      setLoginUsername('');
      setLoginPassword('');
      setEditId(null);
      load();
    } catch (err) {
      onToast?.(err.message, 'error');
    } finally {
      setSaving(false);
    }
  }

  async function eliminar(id) {
    if (!window.confirm('¿Eliminar vendedor?')) return;
    try {
      await api.eliminarVendedor(id);
      onToast?.('Vendedor eliminado');
      load();
    } catch (err) {
      onToast?.(err.message, 'error');
    }
  }

  return (
    <div className="panel">
      <header className="panel-head">
        <div>
          <h2>Vendedores</h2>
        </div>
      </header>

      <form className="form-row" onSubmit={guardar}>
        <input placeholder="Nombre *" value={nombre} onChange={(e) => setNombre(e.target.value)} required />
        <input placeholder="Teléfono" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
        {!editId ? (
          <>
            <input
              placeholder="Usuario login (opcional)"
              value={loginUsername}
              onChange={(e) => setLoginUsername(e.target.value.replace(/\s/g, ''))}
            />
            <input
              type="password"
              placeholder="Contraseña login (opcional)"
              value={loginPassword}
              onChange={(e) => setLoginPassword(e.target.value)}
            />
          </>
        ) : null}
        <button type="submit" disabled={saving}>{editId ? 'Actualizar' : 'Agregar'}</button>
        {editId ? (
          <button type="button" className="ghost" onClick={() => { setEditId(null); setNombre(''); setTelefono(''); }}>
            Cancelar
          </button>
        ) : null}
      </form>

      <div className="cards">
        {vendedores.map((v) => {
          const login = loginDe(v.id);
          return (
            <div key={v.id} className="card">
              <div>
                <strong>{v.nombre}</strong>
                {v.telefono ? <span>{v.telefono}</span> : null}
        <em className="card-app-hint">
                  {login ? `App vendedor · ${login.username || 'usuario'}` : 'Sin acceso — créalo al agregar o en Usuarios'}
                </em>
              </div>
              <div className="card-actions">
                <button type="button" onClick={() => { setEditId(v.id); setNombre(v.nombre); setTelefono(v.telefono || ''); }}>
                  Editar
                </button>
                <button type="button" className="danger" onClick={() => eliminar(v.id)}>Eliminar</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
